<template>
    <!-- The only <Toast /> in the app: this.$toast publishes to a shared bus
    and every mounted container renders every message, so a second one duplicates toasts.
    It lives here, not in App.vue, so Login/Error/etc. get toasts too. -->
    <Toast />
    <Login v-if="$route.path === '/login'" />
    <SignUp v-else-if="$route.path === '/sign-up'" />
    <ResetPassword v-else-if="$route.path === '/reset-password'" />
    <Error v-else-if="$route.path === '/error'" />
    <Access v-else-if="$route.path === '/access'" />
    <NotFound v-else-if="$route.path === '/notfound'" />
    <App :theme="theme" :componentTheme="componentTheme" v-else />
</template>

<script>
import App from './App.vue';
import Error from './pages/Error';
import Access from './pages/Access';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ResetPassword from '@/pages/ResetPassword.vue';

export default {
    data() {
        return {
            theme: 'blue',
            componentTheme: 'blue',
        };
    },
    components: {
        App: App,
        Error: Error,
        Access: Access,
        Login: Login,
        NotFound: NotFound,
        SignUp: SignUp,
        ResetPassword: ResetPassword,
    },
};
</script>

<style scoped></style>
